/* ============================================================================
   Review-provider takeover.

   A review app that injects into `[data-fv-reviews-app]` becomes the single
   source of reviews on the page: Furniva's own summary, list and empty state
   are all suppressed so a customer never sees two sets of reviews or two
   headings.

   Two rules this deliberately keeps:

   · Verification is never inferred from provider markup. The "Verified
     purchase" mark is only ever rendered from Furniva's own records; nothing
     here promotes a provider review to verified.
   · The native state is suppressed only once provider content actually exists,
     so an app that fails to load leaves the honest Furniva state in place.

   Flicker is avoided by checking synchronously on first run before paint where
   possible, and by only ever adding the suppression class — never toggling it
   back and forth as the app streams content in.
   ============================================================================ */
(function () {
  'use strict';

  var mount = document.querySelector('[data-fv-reviews-app]');
  if (!mount) return;

  var section = mount.closest('.fv-pdpsec, section') || mount.parentElement;
  if (!section) return;

  function hasProviderContent() {
    // Any rendered element with real size counts; whitespace and empty
    // placeholder nodes do not.
    if (!mount.children.length) return false;
    return Array.prototype.some.call(mount.children, function (child) {
      return child.offsetWidth > 0 || child.offsetHeight > 0 || (child.textContent || '').trim().length > 0;
    });
  }

  var takenOver = false;

  function apply() {
    if (takenOver || !hasProviderContent()) return;
    takenOver = true;
    section.classList.add('fv-reviews--provider');
    // One-way: once the provider owns the section it keeps it for this page.
    observer.disconnect();
  }

  var observer = new MutationObserver(apply);
  observer.observe(mount, { childList: true, subtree: true });

  apply();
  // Apps commonly inject on load or shortly after; these are bounded re-checks,
  // not a polling loop.
  window.addEventListener('load', apply);
  window.setTimeout(apply, 1200);
  window.setTimeout(apply, 4000);
})();
